
import IconCartOutline from '@mg/web-components/Atoms/Icon/IconCartOutline.vue'
import IconUserOutline from '@mg/web-components/Atoms/Icon/IconUserOutline.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { FeaturesConfig } from '@mg/web-components/types'
import { HeaderIconsBarMobile } from '@mg/micro/vue2/HeaderIconsBarMobile'
import type { HeaderIconTab } from '@mg/micro/vue2/HeaderIconsBarMobile'
import ModalLogin from '~/components/modal/ModalLogin.vue'
import { GQL_LOCAL_CART_AMOUNT } from '~/graphql/gqlLocal/localCart'
import { GET_BASIC_USER_INFO } from '~/graphql/gql/user'
import {
  GQLLocalAccount,
  GQLLocalCart,
  GQLLocalHeader,
  GQLLocalOpenHeaderEnum,
  GQLLocalUi,
  GQLLocalUiInput,
} from '~/graphql/__generated__/interfacesLocal'
import AppLink from '~/components/AppLink.vue'
import ROUTES from '~/config/routes'
import {
  GET_LOCAL_HEADER,
  SET_HEADER_VISIBILITY,
} from '~/graphql/gqlLocal/localHeader'
import { GQLUser } from '~/graphql/__generated__/interfaces'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import HeaderUserSignedMobile from '~/components/header/HeaderUserSignedMobile.vue'
import {
  GQL_LOCAL_MUTATION_SET_UI,
  GQL_LOCAL_UI,
} from '~/graphql/gqlLocal/localUi'

const TAB_NAME_BY_ENUM: Record<GQLLocalOpenHeaderEnum, HeaderIconTab | null> =
  {
    [GQLLocalOpenHeaderEnum.User]: 'user',
    [GQLLocalOpenHeaderEnum.WishList]: null,
    [GQLLocalOpenHeaderEnum.Cart]: 'cart',
  }

@Component<HeaderMobileIcons>({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    cart: {
      fetchPolicy: 'cache-only',
      prefetch: false,
      query: GQL_LOCAL_CART_AMOUNT,
    },
    header: {
      query: GET_LOCAL_HEADER,
    },
    user: {
      query: GET_BASIC_USER_INFO,
      skip() {
        return !this.$shopConfig.user?.id && !this.account?.isLogged
      },
    },
    openHeaderTab: {
      prefetch: false,
      query: GQL_LOCAL_UI,
      update(data: { ui: GQLLocalUi }) {
        return data.ui.openHeaderTab
      },
    },
  },

  components: {
    AppLink,
    HeaderIconsBarMobile,
    IconCartOutline,
    IconUserOutline,
    HeaderUserSignedMobile,
    ModalLogin,
  },
})
export default class HeaderMobileIcons extends Vue {
  typeHeaderTab = GQLLocalOpenHeaderEnum
  openHeaderTab: GQLLocalOpenHeaderEnum | null = null
  cart: GQLLocalCart
  header: GQLLocalHeader
  routes = ROUTES
  user: GQLUser
  account: GQLLocalAccount
  openTimeout: NodeJS.Timeout
  openLogin = false

  @Prop({ required: false, type: Object })
  readonly featuresConfig?: FeaturesConfig

  get openTabName(): HeaderIconTab | null {
    return this.openHeaderTab ? TAB_NAME_BY_ENUM[this.openHeaderTab] : null
  }

  get visibleIcons(): HeaderIconTab[] {
    return this.showCart ? ['user', 'cart'] : ['user']
  }

  get showSearch(): boolean {
    return !this.featuresConfig?.disableHeaderSearch
  }

  get showCart(): boolean {
    return !this.featuresConfig?.disableHeaderCart
  }

  setUi(ui: GQLLocalUiInput) {
    this.$apollo.mutate({
      mutation: GQL_LOCAL_MUTATION_SET_UI,
      variables: {
        ui,
      },
    })
  }

  closeTab() {
    this.setUi({
      openHeaderTab: null,
    })
  }

  outside() {
    if (this.openHeaderTab) {
      this.setUi({
        openHeaderTab: null,
      })
    }
  }

  changeTab(type: GQLLocalOpenHeaderEnum | null) {
    if (type === null) {
      this.openTimeout = setTimeout(() => {
        this.setUi({
          openHeaderTab: null,
        })
      }, 3000)
      return
    }

    this.openTimeout && clearTimeout(this.openTimeout)

    this.searchHide()
    this.setUi({
      openHeaderTab: type,
    })
  }

  searchIconClick() {
    if (this.header.searchIsVisible) {
      this.searchHide()
    } else {
      this.searchShow()
    }
  }

  searchShow() {
    this.closeTab()
    this.saveSearchVisible(true)
  }

  searchHide() {
    this.saveSearchVisible(false)
  }

  saveSearchVisible(visible: boolean) {
    this.$apollo.mutate({
      mutation: SET_HEADER_VISIBILITY,
      variables: {
        isMenuVisible: false,
        isSearchVisible: visible,
      },
    })
  }

  get isLoggedIn(): boolean {
    return !!this.$shopConfig.user?.id || !!this.account?.isLogged
  }

  get cartPieces() {
    return this.cart?.amount?.pieces
  }

  get translations() {
    return {
      account: this.$t('common.cta_customer_account'),
      cart: this.$t('common.txt_cart_navigation_basket'),
      search: this.$t('common.cta_search'),
    }
  }
}
